import { ButtonIcon } from '@dapp/multi-lib/sdaoui/ButtonIcon';
import { Icon } from '@dapp/multi-lib/sdaoui/Icon';
import { Body2 } from 'components/Typography';
import { Input } from 'baseui/input';
import { useState } from 'react';
import { cx } from 'class-variance-authority';
import { twMerge } from 'tailwind-merge';

interface ISpendLimitInput {
  defaultSpendLimit: string;
  customSpendLimit: string;
  onSpendLimitChange: (value: string) => void;
}

export const SpendLimitInput = (props: ISpendLimitInput) => {
  const [isCustomInputActive, setCustomInput] = useState(false);

  const setCustomInputActive = () => setCustomInput(true);
  const setCustomInputDeActive = () => setCustomInput(false);

  return (
    <>
      <div className='py-6'>
        <div className='mb-2 flex flex-col items-start justify-start'>
          <ButtonIcon
            className='px-0 py-0 hover:bg-transparent'
            onClick={() => {
              setCustomInputDeActive();
              props.onSpendLimitChange(props.defaultSpendLimit);
            }}
          >
            <div className='mb-2 flex items-center gap-2'>
              <Icon
                icon={
                  !isCustomInputActive
                    ? 'radio_button_checked'
                    : 'radio_button_unchecked'
                }
                width={16}
                height={16}
                color='#D9D9D9'
              />
              <Body2
                as='div'
                className={cx(
                  twMerge(
                    'text-sm leading-[1.25rem]',
                    !isCustomInputActive ? 'text-white' : 'text-white-400'
                  )
                )}
              >
                Proposed approval limit
              </Body2>
            </div>
          </ButtonIcon>
          <Body2
            as='div'
            className={cx(
              twMerge(
                'ml-6 text-sm',
                !isCustomInputActive ? 'text-white' : 'text-white-400'
              )
            )}
          >
            {props.defaultSpendLimit}
          </Body2>
        </div>
        <div className='mt-2 flex flex-col items-start justify-start'>
          <ButtonIcon
            className='px-0 py-0 hover:bg-transparent'
            onClick={setCustomInputActive}
          >
            <div className='mb-2 flex items-center gap-2'>
              <Icon
                icon={
                  isCustomInputActive
                    ? 'radio_button_checked'
                    : 'radio_button_unchecked'
                }
                width={16}
                height={16}
                color='#D9D9D9'
              />
              <Body2
                as='div'
                className={cx(
                  twMerge(
                    'text-sm leading-[1.25rem]',
                    isCustomInputActive ? 'text-white' : 'text-white-400'
                  )
                )}
              >
                Custom spend limit
              </Body2>
            </div>
          </ButtonIcon>
          <Body2 as='div' className='ml-6 text-sm text-white-400'>
            <Input
              readOnly={!isCustomInputActive}
              overrides={{
                Root: {
                  style: () => ({
                    borderTopColor: '',
                    borderBottomColor: '',
                    borderLeftColor: '',
                    borderRightColor: '',
                    borderTopStyle: 'none',
                    borderBottomStyle: 'none',
                    borderLeftStyle: 'none',
                    borderRightStyle: 'none',
                    backgroundColor: '#1E1E1E',
                  }),
                },
                Input: {
                  style: ({ $theme }) => ({
                    backgroundColor: '#1E1E1E',
                    color: isCustomInputActive
                      ? $theme.colors.white
                      : '#bfbfbf',
                  }),
                },
              }}
              size='compact'
              value={props.customSpendLimit}
              onChange={(e) =>
                props.onSpendLimitChange((e.target as HTMLInputElement).value)
              }
            />
          </Body2>
        </div>
      </div>
    </>
  );
};
